module.exports = __webpack_public_path__ + "static/media/SR105-P5F Copy.759c2bef.png";